module.exports = __webpack_public_path__ + "img/about_banner.58401208.jpg";